import React from 'react';
import { ReactComponent as AlertIcon } from '../../../../../assets/icons/alert-problem.svg';
import { ReactComponent as PaperLess } from '../../../../../assets/icons/paperless.svg';
import { ReactComponent as UploadService } from '../../../../../assets/icons/upload-2.svg';
import { ReactComponent as ManageProfile } from '../../../../../assets/icons/manage-profile.svg';

import CustomSwitch from '../../../../../shared/CustomSwitch/CustomSwitch';

const moreActions = [
  {
    label: 'Switch to paperless',
    id: 'invoiceDeliveryToggle',
    icon: <PaperLess />,
    bgColor: '#E8F5E9',
  },
  {
    label: 'Report a problem',
    id: 'reportToggle',
    icon: <AlertIcon />,
    bgColor: '#FBE3EC',
  },
  {
    label: 'Upgrade services',
    id: 'upgradeServiceToggle',
    icon: <UploadService />,
    bgColor: '#D3F6FC',
  },
  {
    label: 'Manage profile',
    id: 'manageProfileToggle',
    icon: <ManageProfile />,
    bgColor: '#F2E6F3',
  },
];

function MoreActionsComponent({ hidden, switches, onSwitchChange }) {
  return (
    <div id="more-actions">
      <div className="more-actions-grid">
        {moreActions.map((action) => {
          const isDisabled = !switches[action.id]; // check toggle status
          return (
            <div
              key={action.id}
              className={`garden-wall-normal-card more-action ${isDisabled ? 'card-disabled' : ''}`}
            >
              <div style={{ alignSelf: 'flex-end', paddingRight: 20 }}>
                <CustomSwitch
                  checked={!!switches[action.id]}
                  onChange={(value) => onSwitchChange(action.id, value)}
                  size="small"
                  color="var(--primary-color)"
                />
              </div>
              <div
                className="more-icons"
                style={{ background: action.bgColor }}
              >
                {action.icon}
              </div>
              <p className="more-label">{action.label}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const MoreActions = React.memo(MoreActionsComponent, (prevProps, nextProps) => {
  return (
    prevProps.hidden === nextProps.hidden &&
    prevProps.checked === nextProps.checked &&
    JSON.stringify(prevProps.switches) === JSON.stringify(nextProps.switches)
  );
});

export default MoreActions;
